export default [
  {
    code: "en",
    name: "English",
    pricingTable: {
      description: "DESCRIPTION",
      quantity: "QUANTITY",
      rate: "RATE",
      discount: "RATE DISC.",
      total: "PRICE",
      totalAndTaxes: {
        subtotal: "SUBTOTAL",
        total: "TOTAL",
      },
    },
  },
  {
    code: "es",
    name: "Español",
    pricingTable: {
      description: "DESCRIPCIÓN",
      quantity: "CANTIDAD",
      rate: "PRECIO UND.",
      discount: "DTO. UND.",
      total: "TOTAL",
      totalAndTaxes: {
        subtotal: "SUBTOTAL",
        total: "TOTAL",
      },
    },
  },
];
